import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';

import { FavouritesStore } from '@store/modules/ui/sportOffer/favourites/favouritesIndex';
import { UserPreferencesStore } from '@store/modules/ui/user/preferences/preferencesIndex';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import { computed } from '@vue/composition-api';

export function useFavourites() {
    const sportOfferDataStore = useVuexStore<SportOfferDataStore>('data/sportOffer');
    const userPreferencesStore = useVuexStore<UserPreferencesStore>('ui/user/preferences');
    const favouritesStore = useVuexStore<FavouritesStore>('ui/sportOffer/favourites');

    const allTournaments = sportOfferDataStore.getter('tournaments');
    const userTournaments = userPreferencesStore.getter('tournaments');
    const selectedTournamentIds = favouritesStore.getter('filteredTournamentsIds');
    const toggleFilteredTournament = favouritesStore.action('toggleFilteredTournament');
    const clearFilteredTournaments = favouritesStore.action('clearFilteredTournaments');

    const favouriteTournaments = computed(() => {
        return userTournaments.value.filter((item) => !!allTournaments.value[item.id]);
    });

    return {
        favouriteTournaments,
        selectedTournamentIds,
        toggleFilteredTournament,
        clearFilteredTournaments,
    };
}
